import { SelectParameter, SliderVariable } from '../constants/supportedVariablesAndParameters';

import { ClubType } from '../constants/selectOptions';

export const isSliderHidden = (clubType: ClubType, sliderVariable: SliderVariable) =>
  clubType !== 'Driver' && sliderVariable === 'calculators.o.AttackAngle';

export const isSelectHidden = (clubType: ClubType, selectParameter: SelectParameter) =>
  (clubType === 'Driver' && selectParameter === 'TrajectoryType') || (clubType !== 'Driver' && selectParameter === 'OptimizationType');
